import { memo } from 'react';

const FeedbackImage = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={132} height={118} fill="none" {...props}>
        <g clipPath="url(#a)">
            <rect width={130} height={116} x={1} y={1} fill="#F2F2F2" rx={8} />
            <mask
                id="b"
                width={74}
                height={70}
                x={29}
                y={24}
                maskUnits="userSpaceOnUse"
                style={{
                    maskType: 'luminance',
                }}
            >
                <path fill="#fff" d="M102.563 24.176h-73.13v69.647h73.13V24.176Z" />
            </mask>
            <g mask="url(#b)">
                <path
                    fill="#C6C6C6"
                    d="M97.03 52.035h-.022c-2.237 0-4.252-1.282-5.11-3.249-.858-1.969-.385-4.237 1.198-5.744l.016-.016c2.16-2.057 2.161-5.393 0-7.45l-2.519-2.4c-2.16-2.057-5.662-2.057-7.823 0l-.016.016c-1.583 1.507-3.965 1.958-6.032 1.14-2.066-.815-3.412-2.736-3.412-4.866v-.022c0-2.91-2.477-5.268-5.532-5.268h-3.562c-3.056 0-5.532 2.36-5.532 5.268v.022c0 2.13-1.346 4.05-3.412 4.867-2.068.817-4.448.366-6.032-1.141l-.016-.016c-2.16-2.057-5.663-2.057-7.824 0l-2.519 2.4c-2.16 2.056-2.16 5.392 0 7.45l.017.016c1.582 1.507 2.055 3.774 1.198 5.743-.857 1.968-2.874 3.25-5.11 3.25h-.023c-3.053 0-5.53 2.358-5.53 5.269v3.392c0 2.91 2.477 5.268 5.532 5.268h.023c2.236 0 4.252 1.282 5.11 3.25.858 1.97.385 4.237-1.198 5.744l-.017.015c-2.16 2.058-2.16 5.393 0 7.451l2.52 2.4c2.16 2.057 5.662 2.057 7.823 0l.016-.016c1.583-1.508 3.964-1.958 6.031-1.141 2.066.816 3.412 2.736 3.412 4.866v.022c0 2.91 2.477 5.268 5.532 5.268h3.562c3.056 0 5.532-2.359 5.532-5.268v-.022c0-2.13 1.346-4.05 3.412-4.866 2.068-.817 4.448-.367 6.031 1.14l.017.016c2.16 2.058 5.662 2.058 7.823 0l2.519-2.399c2.16-2.057 2.16-5.393 0-7.45l-.016-.016c-1.583-1.507-2.056-3.775-1.198-5.744.857-1.967 2.873-3.25 5.11-3.25h.022c3.055 0 5.532-2.359 5.532-5.268v-3.392c0-2.91-2.477-5.269-5.532-5.269ZM65.999 76.412C55.9 76.412 47.716 68.616 47.716 59c0-9.616 8.185-17.412 18.282-17.412 10.096 0 18.281 7.796 18.281 17.412 0 9.615-8.185 17.41-18.281 17.41Z"
                />
                <path
                    fill="#919191"
                    d="M75.157 59.556c-.138 0-.218-.001-.23-.002-.92-.02-1.647-.746-1.626-1.623.022-.875.782-1.569 1.704-1.548 1.03.02 4.024-.107 5.527-.938 1.396-.77 2.898-3.24 3.314-4.043.407-.786 1.406-1.108 2.23-.721.824.388 1.163 1.338.757 2.123-.21.405-2.122 3.998-4.63 5.383-1.137.63-2.72 1.048-4.705 1.248a24.18 24.18 0 0 1-2.34.12v.001Z"
                />
                <path
                    fill="#E84D4F"
                    d="M86.074 48.59c.533 0 .965-.412.965-.92s-.432-.919-.965-.919c-.533 0-.965.411-.965.919s.432.92.965.92Z"
                />
                <path
                    fill="#919191"
                    d="M87.304 65.187c-1.996.066-3.098-2.392-3.167-4.293l-.722-7.581a3.006 3.006 0 0 1-.015-.383c.058-1.798 1.573-3.268 3.487-3.331 1.705-.056 3.175 1.02 3.61 2.52.1.343.134.7.119 1.056l-.339 7.609a4.32 4.32 0 0 0-.002.221c.026 1.88-1.014 4.117-2.97 4.182Z"
                />
                <path
                    fill="#4E4E4E"
                    d="M74.807 77.344a.437.437 0 0 1-.44-.367.427.427 0 0 1 .381-.476l3.158-.4a.441.441 0 0 1 .499.362.427.427 0 0 1-.381.475l-3.158.401a.428.428 0 0 1-.06.004Z"
                />
                <path
                    fill="#4E4E4E"
                    d="M77.644 76.876c-1.262 0-2.3-.962-2.327-2.17l-.184-8.086v-.112c.07-2.328 2.035-4.18 4.478-4.222l8.953-.243c1.283-.037 2.357.93 2.394 2.154.036 1.224-.977 2.244-2.262 2.28l-8.903.24.18 7.894c.028 1.224-.992 2.238-2.277 2.265h-.052Z"
                />
                <path
                    fill="#00D639"
                    d="M76.478 60.837H66.101c-.429 0-.777-.331-.777-.74V49.789c0-.409.348-.74.777-.74.43 0 .777.331.777.74v9.568h9.6c.43 0 .777.331.777.74s-.347.74-.777.74Z"
                />
                <path
                    fill="#00D639"
                    d="M66.295 61.618c1.028 0 1.86-.793 1.86-1.772 0-.98-.832-1.773-1.86-1.773s-1.861.794-1.861 1.773c0 .979.833 1.772 1.86 1.772Z"
                />
                <path
                    fill="#E84D4F"
                    d="M74.563 58.905c.49-.154.756-.656.595-1.123-.161-.466-.689-.72-1.179-.567l-1.344.421c-.49.154-.757.657-.596 1.123.161.467.69.72 1.18.567l1.344-.421Z"
                />
            </g>
        </g>
        <rect
            width={130}
            height={116}
            x={1}
            y={1}
            stroke="#E6E6E6"
            strokeDasharray="12 12"
            strokeLinecap="round"
            strokeWidth={2}
            rx={8}
        />
        <defs>
            <clipPath id="a">
                <rect width={130} height={116} x={1} y={1} fill="#fff" rx={8} />
            </clipPath>
        </defs>
    </svg>
);
export default memo(FeedbackImage);
